import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-freigeben';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeFreigebenEffects {

    AufgabeFreigeben$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_FREIGEBEN),
        mergeMap((x: ac.PostAufgabeFreigebenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeFreigeben(x.aufgabeFreigebenRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeFreigebenErfolgreichAction(result, x.aufgabeFreigebenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeFreigebenFehlerAction(error, x.aufgabeFreigebenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
